import {useState} from 'react';

import {Button} from '#component/base';
import {ButtonVariants} from '#component/base/Button';
import {ModalRoot} from '#component/base/Modal';
import {theme} from '#theme';

import {SkipNextOrderModalContent} from './SkipNextOrderModalContent';

import {SkipNextOrderModalProps} from './SkipNextOrderModal.types';

export const SkipNextOrderModal = ({
  productVariants,
  skipBtnVariant,
  className,
  buttonLabel,
  size,
}: SkipNextOrderModalProps) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {open && (
        <ModalRoot open={open} onOpenChange={setOpen}>
          <SkipNextOrderModalContent productVariants={productVariants} setOpen={setOpen} />
        </ModalRoot>
      )}
      <Button
        className={className ?? ''}
        variant={skipBtnVariant as ButtonVariants}
        color={theme.colors.eggplantDark}
        onClick={() => setOpen(true)}
        style={{
          ...(size === 'narrow' && {height: '37px'}),
          ...(skipBtnVariant === 'secondary' && {border: `2px solid ${theme.colors.burgundy}`}),
        }}>
        {buttonLabel ?? 'Skip Next Order'}
      </Button>
    </>
  );
};
